import React from 'react';
import PropTypes from 'prop-types';
import { Small } from 'rebass';
import Link from '../link';

const FacebookPageLink = ({ url }) => (
  <Link
    href={url}
    target="_blank"
  >
    <Small>
      facebook
    </Small>
  </Link>
);

FacebookPageLink.propTypes = {
  url: PropTypes.string.isRequired,
};

export default FacebookPageLink;



// WEBPACK FOOTER //
// ./src/app/components/facebook_page_link/index.js